import React from 'react'
import { StyleSheet, css } from 'aphrodite'
import PropTypes from 'prop-types'
import { Inter } from '../../lib/fonts'
import { COLOR_BLACK } from '../../lib/colors'

const UIText = ({ value, dynamicStyle }) => {
  return <p className={css(styles.text, dynamicStyle)}>{value}</p>
}

const styles = StyleSheet.create({
  container: {
    width: '100%',
    height: '100%',
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
  },
  text: {
    fontSize: 18,
    fontFamily: [Inter, 'sans-serif'],
    color: COLOR_BLACK,
  },
  custom: {
    marginRight: 16,
    width: 60,
    height: 60,
  },
})

UIText.propTypes = {
  value: PropTypes.string.isRequired,
  dynamicStyle: PropTypes.node,
  circleColor: PropTypes.string,
}

export default UIText
